import RequestService from './request-service';

/**
 * Boosted Odds Request Service
 */
export class BoostedOddsRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.boostedOdds;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';

    /**
     * Set get params
     * @type {{Sports: Array|number, Tournaments: Array|number, TournamentGroups: Array|number, Categories: Array|number, CategoryGroups: Array|number, Matches: Array|number, OnlyBanner: boolean, Culture: string}}
     */
    this.getParams = {
      Sports: [],
      Tournaments: [],
      TournamentGroups: [],
      Categories: [],
      CategoryGroups: [],
      Matches: [],
      OnlyBanner: false,
      Culture: APP_SETTINGS.player.language || 'en',
      TimeOffset: new Date().getTimezoneOffset(),
      LocalCurrency: APP_SETTINGS.player.currency || null,
      externalUserID: APP_SETTINGS.player.id || null, 
    };
    this.headers = null;
  }
}
